import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface DocumentStatusesInterface {
    formVisible: boolean;
    formVariant: "new" | "edit";
    editId: string;
    editTitle: string;
    editAlias: string;
    editDescription: string;
    editParentId: string;
    editIsActive: boolean | null;
    deleteStatusModalVisible: boolean;
    deleteId?: string;
}

function getInitialState(): DocumentStatusesInterface {
    return {
        formVisible: false,
        formVariant: "new",
        deleteStatusModalVisible: false,
        editId: "",
        editTitle: "",
        editAlias: "",
        editDescription: "",
        editParentId: "",
        editIsActive: null,
    };
}

export const DocumentStatusesSlice = createSlice({
    name: "DocumentStatusesSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => getInitialState(),
        updateFields: (
          state: DocumentStatusesInterface,
          action: PayloadAction<Partial<DocumentStatusesInterface>>
        ) => {
            Object.assign(state, action.payload);
        },

    },

});

export const {updateFields, reset} = DocumentStatusesSlice.actions;

export const DocumentStatusesSelectors = {
    formVisible: (state: RootState) => state.documentStatuses.formVisible,
    formVariant: (state: RootState) => state.documentStatuses.formVariant,
    editId: (state: RootState) => state.documentStatuses.editId,
    editTitle: (state: RootState) => state.documentStatuses.editTitle,
    editAlias: (state: RootState) => state.documentStatuses.editAlias,
    editDescription: (state: RootState) => state.documentStatuses.editDescription,
    editParentId: (state: RootState) => state.documentStatuses.editParentId,
    editIsActive: (state: RootState) => state.documentStatuses.editIsActive,
    deleteModalVisible: (state: RootState) => state.documentStatuses.deleteStatusModalVisible,
    deleteId: (state: RootState) => state.documentStatuses.deleteId,
};

export const DocumentStatusesReducer = DocumentStatusesSlice.reducer;
